import React from 'react';

import { FormattedMessage } from 'react-intl';

import type { SsoProvider } from '../types/login';

interface SsoProvidersProps {
    providers: SsoProvider[];
    returnUrl: string;
    invitationEmailAddress?: string;
    showDivider?: boolean;
}

export const SsoProviders = ({
    providers,
    returnUrl,
    invitationEmailAddress,
    showDivider = false,
}: SsoProvidersProps) => {
    const validProviders = providers.filter((p) => p.callbackPath && p.name);

    if (validProviders.length === 0) return null;

    const buildLoginUrl = (provider: SsoProvider): string => {
        let url = provider.callbackPath;

        if (!url) {
            return '';
        }

        if (returnUrl) {
            const separator = url.includes('?') ? '&' : '?';
            url += `${separator}returnUrl=${encodeURIComponent(returnUrl)}`;
        }

        if (provider.issuer) {
            const separator = url.includes('?') ? '&' : '?';
            url += `${separator}issuer=${encodeURIComponent(provider.issuer)}`;
        }

        if (invitationEmailAddress) {
            const separator = url.includes('?') ? '&' : '?';
            url += `${separator}invitationEmailAddress=${encodeURIComponent(invitationEmailAddress)}`;
        }

        return url;
    };

    return (
        <div>
            <div className="tw-flex tw-flex-col tw-gap-8">
                {validProviders.map((provider) => (
                    <a
                        key={provider.issuer || provider.name}
                        href={buildLoginUrl(provider)}
                        className="tw-flex tw-items-center tw-justify-center tw-gap-8 tw-border tw-border-default tw-rounded tw-px-12 tw-py-8 tw-text-neutral tw-no-underline tw-font-medium hover:tw-bg-neutral-hover tw-transition-colors"
                    >
                        {provider.logoUrl && (
                            <img
                                src={provider.logoUrl}
                                alt=""
                                className="tw-h-[20px] tw-w-[20px] tw-object-contain"
                            />
                        )}
                        <span>
                            <FormattedMessage
                                id="login.continueWithProvider"
                                defaultMessage="Continue with {provider}"
                                values={{ provider: provider.name }}
                            />
                        </span>
                    </a>
                ))}
            </div>

            {showDivider && (
                <div className="tw-flex tw-items-center tw-gap-12 tw-my-16">
                    <div className="tw-flex-1 tw-h-[1px] tw-bg-neutral-border" />
                    <span className="tw-text-neutral-subdued tw-text-l tw-uppercase">
                        <FormattedMessage id="login.or" defaultMessage="or" />
                    </span>
                    <div className="tw-flex-1 tw-h-[1px] tw-bg-neutral-border" />
                </div>
            )}
        </div>
    );
};
